module.exports = "<svg viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Carrot</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Carrot\" fill=\"#FFFFFF\"><polygon id=\"Rectangle-12\" points=\"0 0 16 8.01757812 0 16\"></polygon></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/carrot.svg
// module id = 508
// module chunks = 1